import { createPortal } from "react-dom";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import { useNavItems } from "./useNavItems";
import { useApprovalsCount } from "../../hooks/useApprovalsCount";

const ACTIVE = "border-primary/40 text-primary shadow-neu-in";
const IDLE = "border-border/60 text-muted-foreground shadow-neu-sm hover:text-foreground";

// درج تبويبات لسطح المكتب: تنقّل برمجي (زر لا رابط) كي لا يظهر عنوان الـURL في شريط حالة المتصفح.
export const NavDrawer = ({ open, onClose }) => {
  const { t } = useTranslation();
  const { allowed } = useNavItems();
  const approvals = useApprovalsCount();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isActive = (to) => (to === "/" ? pathname === "/" : pathname === to || pathname.startsWith(`${to}/`));
  const go = (to) => { navigate(to); onClose(); };
  if (!open) return null;
  return createPortal(
    <div className="fixed inset-0 z-[200]" data-testid="nav-drawer">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} data-testid="nav-drawer-backdrop" />
      <aside className="drawer-slide-in absolute inset-y-0 end-0 flex w-72 max-w-[85vw] flex-col gap-2 overflow-y-auto border-s border-border/50 bg-background p-4 shadow-neu">
        <div className="mb-2 flex items-center justify-between">
          <p className="text-base font-black">{t("nav.menu")}</p>
          <button type="button" onClick={onClose} data-testid="nav-drawer-close" className="rounded-2xl p-2 hover:bg-muted/50">
            <X className="h-5 w-5" />
          </button>
        </div>
        {allowed.map(({ to, key, icon: Icon }) => (
          <button
            key={to} type="button" onClick={() => go(to)} data-testid={`drawer-nav-${key}`}
            className={[
              "flex items-center gap-3 rounded-2xl border px-4 py-3 text-start text-sm font-semibold transition-colors",
              isActive(to) ? ACTIVE : IDLE,
            ].join(" ")}
          >
            <Icon className="h-4 w-4" />
            <span className="whitespace-nowrap">{t(`nav.${key}`)}</span>
            {key === "requests" && approvals > 0 ? (
              <span className="ms-auto inline-flex min-w-[20px] items-center justify-center rounded-full bg-destructive px-1.5 text-[11px] font-black text-white">
                {approvals}
              </span>
            ) : null}
          </button>
        ))}
      </aside>
    </div>,
    document.body,
  );
};
